import { useState, useEffect, useCallback } from 'react'

export function useFullscreen() {
  const supported    = 'requestFullscreen' in document.documentElement
  const [isFullscreen, setIsFullscreen] = useState(!!document.fullscreenElement)

  useEffect(() => {
    const onChange = () => setIsFullscreen(!!document.fullscreenElement)
    document.addEventListener('fullscreenchange', onChange)
    return () => document.removeEventListener('fullscreenchange', onChange)
  }, [])

  const enter = useCallback(async () => {
    try { await document.documentElement.requestFullscreen({ navigationUI: 'hide' }) } catch {}
  }, [])

  const exit = useCallback(async () => {
    try { if (document.fullscreenElement) await document.exitFullscreen() } catch {}
  }, [])

  return { isFullscreen, enter, exit, supported }
}
